import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fmt, fmtDate } from "@/lib/format";
import { Scale, AlertTriangle } from "lucide-react";

export default function HacizGorevlerim() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/haciz-gundemi/gorevlerim").then((r) => setTasks(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <div className="bg-white border border-[#E7DECC] rounded-sm mb-6" data-testid="haciz-gorevlerim">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E7DECC]">
        <Scale className="w-4 h-4 text-[#B8933F]" />
        <span className="font-heading font-bold text-sm tracking-tight">Haciz Görevlerim (Gündemdeki Dosyalar)</span>
        <span className="ml-1 px-2 py-0.5 rounded-sm text-xs font-semibold bg-[#B8933F]/10 text-[#B8933F]">{tasks.length}</span>
      </div>
      {tasks.length === 0 ? (
        <div className="px-4 py-8 text-center text-[#8C8377] text-sm" data-testid="haciz-gorevlerim-empty">
          Gündemde bekleyen haciz dosyanız yok. 🎉
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#E7DECC] bg-[#F3ECDD]">
                <th className="px-4 py-2.5 kicker text-left">Borçlu / Dosya</th>
                <th className="px-4 py-2.5 kicker text-left">Tebliğ Şekli</th>
                <th className="px-4 py-2.5 kicker text-left">Mahkeme / Talimat</th>
                <th className="px-4 py-2.5 kicker text-left">İhlal</th>
                <th className="px-4 py-2.5 kicker text-right">Kalan</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((t) => {
                const rec = t.record || {};
                return (
                  <tr key={t.id} onClick={() => navigate(`/icra/${rec.record_id}`)} className="border-b border-[#E7DECC] hover:bg-[#EFE7D6] cursor-pointer transition-colors duration-150" data-testid={`haciz-gorev-row-${t.id}`}>
                    <td className="px-4 py-2"><div className="font-medium">{rec.musteri || "—"}</div><div className="text-xs text-[#8C8377]">{rec.dosya_no || "-"} · {rec.icra_dairesi || "-"}</div></td>
                    <td className="px-4 py-2">{t.teblig_sekli ? <span className="px-2 py-0.5 rounded-sm text-xs font-semibold bg-[#B8933F]/10 text-[#B8933F]">{t.teblig_sekli}</span> : <span className="text-[#8C8377] text-xs">—</span>}</td>
                    <td className="px-4 py-2 text-xs">M: <b className={t.mahkeme_onayi === "VAR" ? "text-[#2F6E4E]" : "text-[#8C8377]"}>{t.mahkeme_onayi || "YOK"}</b> · T: <b className={t.talimat === "VAR" ? "text-[#2F6E4E]" : "text-[#8C8377]"}>{t.talimat || "YOK"}</b></td>
                    <td className="px-4 py-2">
                      {t.ihlaller?.length > 0 ? (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm bg-[#A63A3A]/10 text-[#A63A3A] text-xs font-semibold"><AlertTriangle className="w-3 h-3" /> {t.ihlaller.map((v) => fmtDate(v.taahhut_tarihi)).join(", ")}</span>
                      ) : <span className="text-[#8C8377] text-xs">-</span>}
                    </td>
                    <td className="px-4 py-2 text-right tabular-nums text-[#A63A3A]">{fmt(rec.kalan || 0)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
